import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { TargetAudience } from '../../../models/important-alert.interface';

export interface CreateImportantAlertInput {
  // Pas d'input spécifique nécessaire
}

export interface CreateImportantAlertResult {
  title: string;
  message: string;
  targetAudience: TargetAudience;
}

@Component({
  selector: 'app-create-important-alert-popup',
  templateUrl: './create-important-alert-popup.component.html',
  styleUrls: ['./create-important-alert-popup.component.scss']
})
export class CreateImportantAlertPopupComponent implements OnInit, IDialogContentComponent<CreateImportantAlertResult, CreateImportantAlertInput> {
  input?: CreateImportantAlertInput;
  alertForm: FormGroup;
  TargetAudience = TargetAudience;

  constructor(private readonly formBuilder: FormBuilder) {
    this.alertForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(255)]],
      message: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(2000)]],
      targetAudience: [TargetAudience.All, Validators.required]
    });
  }

  ngOnInit(): void {
    // Méthode requise par l'interface
  }

  getResult(): CreateImportantAlertResult {
    return {
      title: this.alertForm.value.title,
      message: this.alertForm.value.message,
      targetAudience: this.alertForm.value.targetAudience
    };
  }

  isDisabled(): boolean {
    return !this.alertForm.valid;
  }

  get titleControl() {
    return this.alertForm.get('title');
  }

  get messageControl() {
    return this.alertForm.get('message');
  }

  get titleErrorText(): string {
    const control = this.titleControl;
    if (control?.hasError('required')) {
      return 'Le titre est obligatoire';
    }

    if (control?.hasError('minlength')) {
      return 'Le titre doit contenir au moins 5 caractères';
    }

    if (control?.hasError('maxlength')) {
      return 'Le titre ne peut pas dépasser 255 caractères';
    }

    return '';
  }

  get messageErrorText(): string {
    const control = this.messageControl;
    if (control?.hasError('required')) {
      return 'Le message est obligatoire';
    }

    if (control?.hasError('minlength')) {
      return 'Le message doit contenir au moins 10 caractères';
    }

    if (control?.hasError('maxlength')) {
      return 'Le message ne peut pas dépasser 2000 caractères';
    }

    return '';
  }
}
